import * as _ from 'lodash';

export class PreferredProviders {
  static strategies = [
    {id: 'single', name: 'Single'},
    {id: 'multiple', name: 'Multiple'},
    {id: 'round_robin', name: 'Round-robin'}
  ];
  static strategiesMap = _.zipObject(
    _.map(PreferredProviders.strategies, 'id'),
    _.map(PreferredProviders.strategies, 'name')
  );
  static modelAttributes = [
    {id: 'vehicle_category', name: 'Vehicle type'},
    {id: 'payer_category', name: 'Payer type'}
  ];
  static modelAttributesMap = _.zipObject(
    _.map(PreferredProviders.modelAttributes, 'id'),
    _.map(PreferredProviders.modelAttributes, 'name')
  );
  static allowedValues = {
    vehicle_category: [
      {id: 'sedan', name: 'Medical Sedan'},
      {id: 'taxi', name: 'Taxi'},
      {id: 'psych_transport', name: 'Secure Psychiatric Transport'},
      {id: 'wheelchair', name: 'Wheelchair'},
      {id: 'als', name: 'ALS'},
      {id: 'bls', name: 'BLS'},
      {id: 'cct', name: 'CCT'},
      {id: 'stretcher_van', name: 'Stretcher Van'}
    ],
    payer_category: [
      {id: 'facility', name: 'Facility'},
      {id: 'medicaid', name: 'Medicaid'},
      {id: 'medicare', name: 'Medicare'},
      {id: 'patient', name: 'Patient'},
      {id: 'private_insurance', name: 'Private Insurance'}
    ]
  };
  static allowedValuesMap = _.zipObject(
    _.keys(PreferredProviders.allowedValues),
    _.map(
      _.values(PreferredProviders.allowedValues),
      value => _.zipObject(
        _.map(value, 'id'),
        _.map(value, 'name')
      )
    )
  );

  static formatPreferredProviderRules(data) {
    const filteredData = data.map(function (ruleset) {
        return {
          'strategy': ruleset['strategy'],
          'model_attribute': ruleset['rules'][0]['model_attribute'],
          'value': ruleset['rules'][0]['value'],
          'transportation_company_ids': ruleset['transportation_company_id'],
          'collapsed': false,
          'selectedProviderTemp': '',
          'dataSource': null
        };
      }
    );

    // The following code groups the data so that all transportation_company_ids
    // get grouped as per strategy and then (model_attribute, value).
    let groupedData = _.groupBy(filteredData, (x) => x['strategy']);
    groupedData  = _.mapValues(groupedData, arr => {
      const a = _.groupBy(arr, x => `${x['model_attribute']}-${x['value']}`);
      const b = _.mapValues(a, c => ({
        model_attribute: c[0].model_attribute,
        value: c[0].value,
        transportation_company_ids: _.map(c, 'transportation_company_ids'),
        collapsed: c[0].collapsed,
        selectedProviderTemp: c[0].selectedProviderTemp,
        dataSource: c[0].dataSource
      }));

      return _.values(b);
    });

    return groupedData;
  }

  static generatePayload(data) {
    const payload = _.cloneDeep(data);
    let i = payload['ruleset_data'].length;
    const rulesetData = _.each(payload['ruleset_data'], x => {
      delete x['collapsed'];
      delete x['dataSource'];
      delete x['selectedProviderTemp'];
      i--;
      x['priority'] = i;
      x['comparator'] = x['model_attribute'] === 'vehicle_category' ? 'in' : 'eq';
      return x;
    });

    return {
      strategy: payload['strategy'],
      ruleset_data: rulesetData
    };
  }
}
